import React from 'react';
import { Link } from 'react-router-dom';
import { Longhorn } from '../storefront/icons';

// Endless ribbon of collection names. Two identical groups scroll by exactly
// one group's width, so the loop is seamless; the second copy is hidden from
// assistive tech and the tab order.
const CollectionMarquee = ({ collections }) => (
  <section className="tp-marquee" aria-label="Collections">
    <div className="tp-marquee__track">
      {[0, 1].map((copy) => (
        <ul className="tp-marquee__group" key={copy} aria-hidden={copy === 1 || undefined}>
          {collections.map((collection) => (
            <li key={collection.id}>
              <Link
                to={collection.to}
                className="tp-marquee__item"
                tabIndex={copy === 1 ? -1 : undefined}
              >
                {collection.title}
              </Link>
              <Longhorn className="tp-marquee__sep" />
            </li>
          ))}
        </ul>
      ))}
    </div>
  </section>
);

export default CollectionMarquee;
